import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { ReportNR7AssessmentExportRequest } from '../requests/ReportNR7AssessmentRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ReportNR7AssessmentExport = (values, userId) => async (dispatch) => {
	await ReportNR7AssessmentExportRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
